import { SET_MODULES } from './types';
import Axios from 'functions/Axios';
import { API_URI } from 'Constant';

export const setModules = (modules) => ({
  type: SET_MODULES,
  payload: modules,
});

export const fetchModules = () => {
  return async (dispatch) => {
    var modulesResponse

    try {
      modulesResponse = await Axios.get(`${API_URI}/clients/getlistofmoduleV2`);
    } catch (Error) {
      console.log(Error);
      modulesResponse = await Axios.get(`${API_URI}/clients/getlistofmoduleV2`);
    }

    const sortedModules = modulesResponse.data.data.sort((a, b) =>
      a.moduleName.localeCompare(b.moduleName)
    );
      dispatch(setModules(sortedModules));
  };
};
